import {
  BirdviewSection,
  BirdviewTileKey,
  DashboardTileTone,
} from '../DashboardBirdview.constants'

import EmailIcon from '../../../icons/email.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const BirdviewOversightWidget = {
  Activities: 'activities',
  Attention: 'attention',
  Communication: 'communication',
  CriticalRequests: 'criticalRequests',
  DocFlows: 'docFlows',
  Greta: 'greta',
  Portfolio: 'portfolio',
  TeamLoad: 'teamLoad',
}

export const BIRDVIEW_OVERSIGHT_LAYOUT = {
  left: [
    BirdviewOversightWidget.Activities,
    BirdviewOversightWidget.Portfolio,
    BirdviewOversightWidget.CriticalRequests,
    BirdviewOversightWidget.Communication,
  ],
  right: [
    BirdviewOversightWidget.Attention,
    BirdviewOversightWidget.TeamLoad,
    BirdviewOversightWidget.DocFlows,
    BirdviewOversightWidget.Greta,
  ],
}

export const BIRDVIEW_OVERSIGHT_TILES = [
  {
    Icon: TaskIcon,
    key: BirdviewTileKey.Overdue,
    labelKey: 'DashboardBirdview.TileOverdueKey',
    sectionKey: BirdviewSection.TileOverdue,
    tone: DashboardTileTone.Success,
  },
  {
    Icon: ServiceRequestIcon,
    key: BirdviewTileKey.Unassigned,
    labelKey: 'DashboardBirdview.TileUnassignedKey',
    sectionKey: BirdviewSection.TileUnassigned,
    tone: DashboardTileTone.Warning,
  },
  {
    Icon: ServiceRequestIcon,
    key: BirdviewTileKey.Backlog,
    labelKey: 'DashboardBirdview.TileBacklogKey',
    sectionKey: BirdviewSection.TileBacklog,
    tone: DashboardTileTone.Info,
  },
  {
    Icon: EmailIcon,
    key: BirdviewTileKey.Unread,
    labelKey: 'DashboardBirdview.TileUnansweredKey',
    sectionKey: BirdviewSection.TileUnread,
    tone: DashboardTileTone.Purple,
  },
]
